export default __webpack_public_path__ + "static/media/chimica.e51291ea.svg";